import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'How does the one-time payment work?',
  answer: 'You pay once and get lifetime access to Daily Serve. No recurring subscriptions, no hidden fees. You own your license forever.'
}, {
  question: 'Can I upgrade from Professional to Enterprise later?',
  answer: "Yes, you can upgrade at any time. Simply pay the difference between the two plans and you'll be upgraded immediately."
}, {
  question: 'Is there a free trial?',
  answer: 'Yes! We offer a 14-day free trial with full access to all features. No credit card required to start.'
}, {
  question: 'How many team members can I add?',
  answer: 'The Professional plan supports up to 10 team members, while the Enterprise plan offers unlimited team members.'
}, {
  question: 'Can clients access Daily Serve?',
  answer: 'Yes! Both plans include client portal access. You can invite clients to view their projects, communicate with your team, and access shared files.'
}, {
  question: 'What integrations are available?',
  answer: 'Daily Serve integrates with popular tools like Slack, Google Calendar, Dropbox, and more. Enterprise plans get access to premium integrations and API access.'
}, {
  question: 'Is my data secure?',
  answer: 'Absolutely. We use enterprise-grade encryption, regular backups, and follow industry best practices to keep your data safe and secure.'
}, {
  question: 'What kind of support do you offer?',
  answer: 'Professional plans include email support with 24-hour response times. Enterprise plans get priority support with dedicated account managers.'
}, {
  question: 'Can I export my data?',
  answer: 'Yes, you can export all your data at any time in standard formats like CSV and JSON.'
}, {
  question: 'Do you offer refunds?',
  answer: "Yes, we offer a 30-day money-back guarantee. If you're not satisfied, contact us for a full refund."
}];
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-355">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex justify-between items-center text-left hover:text-brand-teal transition-colors duration-200" data-id="element-356">
        <span className="text-lg font-medium text-brand-blue" data-id="element-357">{question}</span>
        <ChevronDownIcon className={`h-5 w-5 text-brand-teal transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-358" />
      </button>
      {isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="pb-6" data-id="element-359">
          <p className="text-gray-600" data-id="element-360">{answer}</p>
        </motion.div>}
    </div>;
};
export const FAQs = () => {
  return <div className="bg-white" data-id="element-361">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-362">
        <div className="container-custom" data-id="element-363">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-364">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-365">
              Frequently asked questions
            </h1>
            <p className="text-xl text-gray-600" data-id="element-366">
              Find answers to common questions about Daily Serve.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-367">
        <div className="container-custom max-w-3xl" data-id="element-368">
          <div data-id="element-369">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.05
          }} data-id="element-370">
                <FAQItem question={faq.question} answer={faq.answer} data-id="element-371" />
              </motion.div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-brand-light" data-id="element-372">
        <div className="container-custom text-center" data-id="element-373">
          <h2 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-374">
            Still have questions?
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-375">
            We're here to help. Get in touch with our team.
          </p>
          <a href="mailto:rapeezshrestha385@gmail.com" className="btn-primary" data-id="element-376">
            Contact us
          </a>
        </div>
      </section>
    </div>;
};